// Person names are shown in capitals in lists (JAIS convention), whatever case they were typed in.
const upperName = (value) => {
    const text = String(value ?? '').trim();
    return text ? text.toLocaleUpperCase('ms-MY') : '';
};

export default upperName;
